import { createApp } from 'vue'
import { createPinia } from 'pinia'
// import { createUnhead } from '@unhead/vue'
import { createHead } from '@unhead/vue/client'
import App from './App.vue'
import { router } from './router'
import i18n from './plugins/i18n'
import socketio from '@/plugins/socket'
import { VueMasonryPlugin } from 'vue-masonry'
import './assets/css/variables.css'
import Clarity from '@microsoft/clarity'
import vue3GoogleLogin from 'vue3-google-login'

const { VITE_MS_CLARITY_ID, VITE_GIS_CLIENT_ID } = import.meta.env
Clarity.init(VITE_MS_CLARITY_ID)

const app = createApp(App)
const pinia = createPinia()
const head = createHead()

app.use(vue3GoogleLogin, {
  clientId: VITE_GIS_CLIENT_ID
})

app.use(pinia)
app.use(head)
app.use(i18n)
app.use(router)
app.use(socketio)
app.use(VueMasonryPlugin)
app.mount('#app')

// 等待路由准备就绪后再挂载应用
// router.isReady().then(() => {
//   app.mount('#app')
//   // 在应用挂载后，延迟触发渲染事件，确保动态内容已加载
//   setTimeout(() => {
//     document.dispatchEvent(new Event('render-event'))
//   }, 500) // 可根据实际数据加载情况调整延时
// })
